
import { Location } from "./location";
import FirestoreModel from "../FirestoreModel";


export class Bay extends FirestoreModel<Bay>() {

  name: string;

  static collectionPath = (companyId: string, locationId: string) => [...Location.refPath(companyId, locationId), "bays"];
  static refPath = (companyId: string, locationId: string, bayId: string) => [...this.collectionPath(companyId, locationId), bayId];
  static collection(companyId: string, locationId: string) {
    return this.pathToCollection(this.collectionPath(companyId, locationId));
  }
  static ref(companyId: string, locationId: string, bayId: string) {
    return super.pathToRef(this.refPath(companyId, locationId, bayId));
  }

  constructor(snapshot: any) {
    super(snapshot);
    const data = snapshot.data();
    this.name = data.name;
    // const data = snapshot.data();
  }
}